import React, { useState } from "react";
import { Button, Input, Form, Image } from "antd";
import { logo1, signinPopup } from "../../assets/images";
import { resetPassword } from "../../redux/actions/Auth/auth.actions";
import { useDispatch, useSelector } from "react-redux";
import { clearMessage } from "../../redux/actions/Message/message.actions";
import { useEffect } from "react";
import styles from "./ForgotPassword.module.css";
import { COLORS } from "../../config/theme";
import { useParams, useHistory } from "react-router-dom";
import { openNotification } from "../../redux/actions/Notification/notifications.action";

const ForgotPassword = () => {
  const { danger1, primaryDark } = COLORS;
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const { id, token } = params;
  const { message } = useSelector((state) => state.message);

  const { Item } = Form;
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const handleFinish = (values) => {
    const { password, confirmPassword } = values;
    const data = { password, confirmPassword, id, token };
    setIsLoading(true);
    dispatch(resetPassword(data))
      .then(() => {
        history.push("/");
        setIsLoading(false);
      })
      .catch((error) => {
        openNotification({
          message: "Error!",
          description: `${message}`,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  const handleFinishFailed = (err) => {
    console.log(err);
  };
  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className={styles.main}>
      <header className={styles.header}>
        {/* logo */}
        <img src={logo1} alt="" className={styles.logo} />
        {/* links */}
        <div className={styles.links__container}>
          <button
            onClick={() => {
              window.open("https://wavecards.com.au/support", "_blank");
            }}
            className={styles.button}
          >
            Contact Us
          </button>
        </div>
      </header>
      <div id="home" className="heroBlock">
        <div className={styles.modal}>
          <div
            style={{
              display: "flex",
              height: "-webkit-fill-available",
              width: "-webkit-fill-available",
            }}
          >
            <div className={styles.popImage}>
              <span
                style={{
                  color: "#727272",
                  textAlign: "center",
                  paddingTop: "20%",
                  width: "50%",
                }}
              >
                {`Welcome to Wave Cards Management Admin Portal`}
              </span>
              <Image src={signinPopup} preview={false} draggable={false} />
            </div>

            <Form
              onFocus={() => dispatch(clearMessage())}
              form={form}
              onFinish={handleFinish}
              onFinishFailed={handleFinishFailed}
              name="resetPassword"
              style={{
                flex: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  position: "relative",
                  marginTop: ".5rem",
                  backgroundColor: "#001529",
                  width: "60%",
                  justifyContent: "center",
                  borderTopRightRadius: 30,
                  borderBottomRightRadius: 30,
                }}
              >
                <span
                  style={{
                    color: "white",
                    paddingTop: 5,
                    paddingBottom: 5,
                  }}
                >
                  Welcome Back
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  position: "relative",
                  marginTop: "1rem",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <span
                  style={{
                    color: "black",
                    paddingTop: 5,
                    paddingBottom: 5,
                    fontWeight: "600",
                  }}
                >
                  Reset Your Passwrd
                </span>
              </div>
              <div
                style={{
                  paddingRight: 60,
                  paddingLeft: 60,
                  marginTop: ".5rem",
                }}
              >
                <>
                  <label>Password</label>
                  <Item
                    hasFeedback
                    name="password"
                    rules={[
                      { required: true, message: "Password is required!" },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      style={{
                        borderWidth: 1,
                        borderColor: "#D9D9D9",
                        borderRadius: 12,
                      }}
                    />
                  </Item>
                </>
                <>
                  <label>Confirm Password</label>
                  <Item
                    hasFeedback
                    name="confirmPassword"
                    rules={[
                      { required: true, message: "Password is required!" },
                    ]}
                  >
                    <Input.Password
                      className="br-8"
                      size="large"
                      style={{
                        borderWidth: 1,
                        borderColor: "#D9D9D9",
                        borderRadius: 12,
                      }}
                    />
                  </Item>
                </>
                <Item>
                  <Button
                    className="br-8"
                    style={{
                      background: message ? danger1 : primaryDark,
                      borderColor: message ? danger1 : primaryDark,
                    }}
                    loading={isLoading}
                    type="primary"
                    htmlType="submit"
                    size="large"
                    block
                  >
                    {message ? message : "Reset Password"}
                  </Button>
                </Item>

                <div
                  style={{
                    display: "flex",
                    position: "relative",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  {/* <span
                  onClick={() => {}}
                  style={{
                    color: "black",
                    paddingTop: 5,
                    paddingBottom: 5,
                  }}
                >
                  
                </span> */}
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <footer className={styles.footer}>
        <div className={styles.footerTextContainer}>
          <span className={styles.footerText}>WAVE CARDS</span>
        </div>
        <div className={styles.footerTextContainer}>
          <span className={styles.footerText}>WAVE CARDS ENTERPRISE</span>
        </div>
        <div className={styles.footerTextContainer}>
          <span className={styles.footerText}>ABOUT US</span>
        </div>
        <div className={styles.footerTextContainer}>
          <span className={styles.footerText}>HELP</span>
        </div>
        <div className={styles.footerTextContainer}>
          <span className={styles.footerText}>CONTACT US</span>
        </div>
      </footer>
    </div>
  );
};

export default ForgotPassword;
